import { createActions } from 'redux-actions';

const {
  updateVehicle,
  updateVehicleSuccess,
  updateVehicleError,
  archiveVehicle,
  archiveVehicleSuccess,
  archiveVehicleError,
  restoreVehicle,
  restoreVehicleSuccess,
  restoreVehicleError,
} = createActions(
  'UPDATE_VEHICLE',
  'UPDATE_VEHICLE_SUCCESS',
  'UPDATE_VEHICLE_ERROR',
  'ARCHIVE_VEHICLE',
  'ARCHIVE_VEHICLE_SUCCESS',
  'ARCHIVE_VEHICLE_ERROR',
  'RESTORE_VEHICLE',
  'RESTORE_VEHICLE_SUCCESS',
  'RESTORE_VEHICLE_ERROR'
);

export {
  updateVehicle,
  updateVehicleSuccess,
  updateVehicleError,
  archiveVehicle,
  archiveVehicleSuccess,
  archiveVehicleError,
  restoreVehicle,
  restoreVehicleSuccess,
  restoreVehicleError,
};
